import { Permissao } from "./Permissao";

export interface Perfil {
    id?: string;
    nome?: string;
    descricao?: string;
    permissoes: Permissao[];
}

export class PerfilUtils {

    // Verifica se o perfil tem todas as permissões necessárias
    static verificarTodasPermissoes(perfil: Perfil, permissoesNecessarias: string[]): boolean {
        const permissoesUsuario = perfil.permissoes.map(permissao => permissao.nome);
        return permissoesNecessarias.every(p => permissoesUsuario.includes(p));
    }

    // Verifica se o perfil tem pelo menos uma das permissões necessárias
    static verificarQualquerPermissao(perfil: Perfil, permissoesNecessarias: string[]): boolean {
        const permissoesUsuario = perfil.permissoes.map(permissao => permissao.nome);
        return permissoesNecessarias.some(p => permissoesUsuario.includes(p));
    }

    // Verifica se o perfil tem todas as permissões necessárias, considerando o bancaId
    static verificarTodasPermissoesComBancaId(perfil: Perfil, permissoesNecessarias: string[], bancaId: string): boolean {
        const permissoesComBancaId = permissoesNecessarias.map(p => `${p}-${bancaId}`);
        return this.verificarTodasPermissoes(perfil, permissoesComBancaId);
    }

    // Verifica se o perfil tem pelo menos uma das permissões necessárias, considerando o bancaId
    static verificarQualquerPermissaoComBancaId(perfil: Perfil, permissoesNecessarias: string[], bancaId: string): boolean {
        const permissoesComBancaId = permissoesNecessarias.map(p => `${p}-${bancaId}`);
        return this.verificarQualquerPermissao(perfil, permissoesComBancaId);
    }

    // Cria um perfil com um nome específico (função utilitária)
    static criarPerfilChumbado(nome: string): Perfil {
        return { nome: nome, permissoes: [] as Permissao[] };
    }
}